import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { pipe } from "Utils/";
import { HeaderV2 } from "ComponentsUI/Header";
import { PaddingBottom } from "ComponentsUI/Spacings";
import PlanBContainer from "Containers/PlanBContainer";

const TariffsContainer = (props) => {
	const {
		match: { params },
	} = props;
	let text = props.ApplicationModel.text;
	if (!props.tariffs) {
		return <Loading />;
	}
	const providersUrl = generateUrl(Routes.ProviderRates.route, {
		regionUrl: params.regionUrl,
		providerName: params.providerName,
	});

	if (!props.tariffs.length) {
		return null;
		/*return (
            <EmptyStubWrapper
                headerText={text.OOPS}
                displayText={text.OOPS_TEXT}
                iconHeader={"icon-hearts"}
                hideButton={true}
            />
        );*/
	}

	return (
		<>
			{props.showHeaderV2 && <HeaderV2 textHeader={props.textHeaders} />}
			<PaddingBottom>
				<PlanBContainer
					tariffs={props.tariffs}
					urlDefault={providersUrl}
					isReviewsProviders={props.isReviewsProviders}
				/>
			</PaddingBottom>
		</>
	);
};

export default pipe(
	observer,
	inject("ApplicationModel"),
	withDefaultParams,
	withRouter
)(TariffsContainer);
